// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__38AqM","colCheckbox":"styles_colCheckbox__2z4vb"};